<template>
  <div
    class="settings-page d-flex flex-column i-px-12 i-py-11 align-items-center"
    :class="{
      'collect-config-overlay':
        $route.name.startsWith('collect-config-email-customization') ||
        $route.name.startsWith('collect-config-portal-customization'),
    }"
  >
    <div class="settings-page-heading">
      <h3 class="i-text-heading-4 i-text-neutral-120 i-mb-6">Settings</h3>
    </div>
    <div class="settings-page-menu i-mb-14">
      <b-nav class="i-secondary-level-menu">
        <b-nav-item
          class="i-text-subheading-2"
          :class="{ active: $route.name.startsWith('account-settings') }"
          :active="$route.name.startsWith('account-settings')"
          :to="{ name: 'account-settings-view' }"
        >
          Account
        </b-nav-item>
        <b-nav-item
          class="i-text-subheading-2"
          :class="{ active: $route.name.startsWith('team-settings') }"
          :active="$route.name.startsWith('team-settings')"
          :to="{ name: 'team-settings-view' }"
        >
          Team
        </b-nav-item>
        <b-nav-item
          v-if="collectEnabled"
          class="i-text-subheading-2"
          :class="{ active: $route.name.startsWith('collect-config-settings') }"
          :active="$route.name.startsWith('collect-config-settings')"
          :to="{ name: 'collect-config-settings-view' }"
        >
          Collect
        </b-nav-item>
        <b-nav-item
          class="responsive-hide i-text-subheading-2"
          :class="{ active: $route.name.startsWith('api-settings') }"
          :active="$route.name.startsWith('api-settings')"
          :to="{ name: 'api-settings-list-keys' }"
        >
          API Keys
        </b-nav-item>
        <b-nav-item
          class="responsive-hide i-text-subheading-2"
          :class="{ active: $route.name.startsWith('webhooks-settings') }"
          :active="$route.name.startsWith('webhooks-settings')"
          :to="{ name: 'webhooks-settings-list' }"
        >
          Webhooks
        </b-nav-item>
        <b-nav-item
          class="responsive-hide i-text-subheading-2"
          :class="{ active: $route.name.startsWith('notifications-settings') }"
          :active="$route.name.startsWith('notifications-settings')"
          :to="{ name: 'notifications-settings-view' }"
        >
          Notifications
        </b-nav-item>
        <b-nav-item
          class="responsive-hide i-text-subheading-2"
          :class="{ active: $route.name.startsWith('saml-settings') }"
          :active="$route.name.startsWith('saml-settings-')"
          :to="{ name: 'saml-settings-view' }"
        >
          SAML
        </b-nav-item>
        <!-- Hidden on larger screens -->
        <b-nav-item-dropdown
          id="more-dropdown"
          text="More"
          class="more-link i-text-subheading-2"
          toggle-class="nav-link-custom"
          right
        >
          <b-dropdown-item
            class="i-text-subheading-2"
            :class="{ active: $route.name.startsWith('api-settings') }"
            :active="$route.name.startsWith('api-settings')"
            :to="{ name: 'api-settings-list-keys' }"
          >
            API Keys
          </b-dropdown-item>
          <b-dropdown-item
            class="i-text-subheading-2"
            :class="{ active: $route.name.startsWith('webhooks-settings') }"
            :active="$route.name.startsWith('webhooks-settings')"
            :to="{ name: 'webhooks-settings-list' }"
          >
            Webhooks
          </b-dropdown-item>
          <b-dropdown-item
            class="i-text-subheading-2"
            :class="{
              active: $route.name.startsWith('notifications-settings'),
            }"
            :active="$route.name.startsWith('notifications-settings')"
            :to="{ name: 'notifications-settings-view' }"
          >
            Notifications
          </b-dropdown-item>
          <b-dropdown-item
            class="i-text-subheading-2"
            :class="{ active: $route.name.startsWith('saml-settings') }"
            :active="$route.name.startsWith('saml-settings')"
            :to="{ name: 'saml-settings-view' }"
          >
            SAML
          </b-dropdown-item>
        </b-nav-item-dropdown>
      </b-nav>
    </div>
    <div class="d-flex justify-content-center w-100">
      <div class="settings-page-view">
        <router-view />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  computed: {
    ...mapGetters({
      isOrgAdmin: 'isOrgAdmin',
      collectEnabled: 'collectEnabled',
    }),
  },
  watch: {
    '$route.hash': function () {
      if (this.$route.hash) {
        this.scrollToSection(this.$route.hash);
      } else {
        document.querySelector('.app-wrapper').scrollTo(0, 0);
      }
    },
  },
  methods: {
    scrollToSection(selector) {
      const element = document.querySelector(selector);
      if (element) {
        element.scrollIntoView({
          behavior: 'smooth',
          block: 'start',
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.settings-page {
  &-view,
  &-heading,
  &-menu {
    width: 100%;
    max-width: 1200px;
    position: sticky;
    top: 0;
    background-color: $light-neutral-default !important;

    .more-link {
      display: none;
    }

    @include respond-to('large') {
      width: 100%;
      min-width: auto !important;

      .responsive-hide {
        display: none !important;
      }

      .more-link {
        display: list-item;
      }
    }
  }

  ::v-deep &-block {
    display: flex;
    flex-direction: row;
    justify-content: space-between;

    @include respond-to('medium') {
      flex-direction: column;
      justify-content: flex-start;

      &-title {
        padding-right: 0;
        padding-bottom: 32px;
      }
    }

    &-title {
      width: 100%;
      padding-right: 64px;
    }

    &-content {
      width: 100%;
      max-width: 650px;
    }
  }

  &-view {
    z-index: 0 !important;
  }

  .collect-config-overlay &-heading,
  .collect-config-overlay &-menu {
    display: none;
  }
}
</style>
